export const formTracker = {
    namespaced: true,
    state: {
        sidebarConfig: null,
        loadCancel: null
    },
    getters: {
        getSidebarConfig: state => state.sidebarConfig
    },
    mutations: {
        SET_SIDEBAR_CONFIG(state, payload){
            state.sidebarConfig = payload
        },
        SET_LOAD_CANCEL(state, payload) {
            state.loadCancel = payload
        }
    },
    actions: {
        setSidebarConfig({ commit }, payload) {
            commit('SET_SIDEBAR_CONFIG', payload)
        },
        setLoadCancel({ commit }, payload) {
            commit('SET_LOAD_CANCEL', payload)
        }
    }
}